export default {
  mixinName: "featureMixin",
  props: {
    featureName: {
      type: String,
      required: true,
    },
  },
  computed: {
    storeFeature() {
      return this.$store.getters["features/feature"](this.featureName);
    },
    storeFeatureLoadable() {
      return this.storeFeature?.required || this.storeFeature?.enabled;
    },
  },
};
